import React from "react";
import { t } from "i18next";
import { Result, Spin } from "antd";
import withDataTable from "components/Report/withDataTable";
import { getLeaveBookBalance } from "services/leave_report";
import { Util } from "common/util";
import Enum from "common/enums";
import moment from "moment";
import { getHeaders, getURl } from "services/core";
const pathName = "/reports/leaves/employee-leave-book-balance";
const columns = [
  {
    title: t("text_leave_employee"),
    dataIndex: "employeeName",
    key: "employeeName",
    className: "header-import-report",
    fixed: true,
    width: 270
  },
];

function getCustomColumns(response) {
  const resultLeaveItem = response.leaveItems.map(leaveItem => {
    return {
      title: leaveItem.name,
      className: "header-report",
      children: [
        {
          title: "Taken",
          dataIndex: leaveItem.name,
          key: leaveItem.name,
          className: "header-report",
          render: (taken, record) => {
            const payload = record.payload ? record.payload : [];
            // eslint-disable-next-line
            const foundLeavePayload = payload.find(value => value.lId == leaveItem.id);
            if (foundLeavePayload) {
              if (foundLeavePayload.type === Enum.LEAVE_TYPE.COMPENSATION) {
                if (foundLeavePayload["number"] !== 0) {
                  return taken = foundLeavePayload["number"].toFixed(1).replace(/\.0+$/, '');
                } else {
                  return undefined;
                }
              } else {
                return taken = foundLeavePayload["number"].toFixed(1).replace(/\.0+$/, '')
              }
            };
          }
        },
        {
          title: "Balance",
          dataIndex: "Annual",
          key: "Annual",
          className: "header-report",
          render: (balance, record) => {
            if ([Enum.LEAVE_TYPE.SICK_LEAVE, Enum.LEAVE_TYPE.UNPAID_LEAVE].includes(leaveItem.type)) {

            } else {
              const payload = record.payload ? record.payload : [];
              // eslint-disable-next-line
              const foundLeavePayload = payload.find(value => value.lId == leaveItem.id);

              if (foundLeavePayload) {
                if (foundLeavePayload.type === Enum.LEAVE_TYPE.COMPENSATION) {
                  if (foundLeavePayload["remain"] !== 0) {
                    return foundLeavePayload["remain"].toFixed(1).replace(/\.0+$/, '');
                  } else {
                    return undefined;
                  }
                } else {
                  let remainLeave = foundLeavePayload["remain"];
                  return remainLeave.toFixed(1).replace(/\.0+$/, '');
                }

              }
            }
          }
        },
      ]
    };
  });
  return resultLeaveItem;

}

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  let limit = defaultPageSize;
  let current = defaultCurrent;

  if (params.get("date")) {
    option["date"] = params.get("date");
  }

  if (params.get("employeeId")) {
    option["employeeId"] = params.get("employeeId");
  }

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  return getLeaveBookBalance(option);
}

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.get("employeeId")) {
      option["employeeId"] = params.get("employeeId");
    }

    option["isExport"] = true;

    getLeaveBookBalance(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully employee booked and balance!"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}


function getDataSelectSearch(value) {
  if (value) {
    const search = JSON.stringify({
      column: ["name"],
      value: value,
    });
    return fetch(
      `${getURl()}/employee/v1/lists?offset=0&limit=15&search=${search}`,
      {
        headers: getHeaders(),
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((response) =>
        response.data.map((value) => ({
          label: `${value.name}`,
          value: value.id,
        }))
      );
  }
  return [];
}

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("date")) params.set("date", moment().format("YYYY"));
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};



export default withDataTable({
  title: t("text_leave_report"),
  subTitle: t("text_employee_book_balance"),
  backLink: "/reports/leaves",
  onShowSelect: true,
  onShowInputSearch: false,
  allowClearPayroll: false,
  showExport: true,
  showDate: true,
  pickerDate: "year",
  dateFormat: "YYYY",
  datePlaceholder: t("text_mm_yyyy"),
  pathName,
  columns,
  getCustomColumns,
  buttonOption: ExportFormLoader,
  getResponseData: (response) => {
    return {data : response.leaves,pagination : response.pagination}
  },
  getData,
  componentWillMount,
  getDataSelectSearch,
  showPagination: true,
});
